import script from "./approvalRequestReport.vue?vue&type=script&setup=true&lang=js"
export * from "./approvalRequestReport.vue?vue&type=script&setup=true&lang=js"

import "./approvalRequestReport.vue?vue&type=style&index=0&id=0fb5da28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb5da28"]])

export default __exports__